<template>
  <div class="news-detail">
    <p class="news-title">
      {{ getCnOrEn(newsDetail?.titleCn, newsDetail?.title) }}
    </p>

    <p class="news-tag mb-4 mt-2" @click="handleClickTag">
      {{ $t(currentNewsTag) }}
    </p>

    <p class="news-time flex items-center">
      <JcImg :level="1"
        src="https://resources.jctrans.com/res/era-h5/h5/img/icon_news_time.png"
        class="size-5"
      />
      {{
        $dayjs(newsDetail?.auditTime)
          .locale('en-US')
          .format(isCn ? 'YYYY-MM-DD' : 'D-MMM-YYYY')
      }}
    </p>

    <div class="border-l-divide-line-color h-[1px] bg-[#E7E7E8] my-6" />

    <div
      class="news-content break-words min-h-[35vh]"
      v-html="
        getCnOrEn(
          newsDetail?.contentCn || newsDetail?.content,
          newsDetail?.content || newsDetail?.contentCn,
        )
      "
    />

    <div class="border-l-divide-line-color h-[1px] bg-[#E7E7E8] my-6" />

    <a
      v-if="prevNews"
      class="recommend-arrow"
      :href="
        getLineHref(`/${currentType}/${prevNews.id}/`, isCn ? '/cn' : '/en')
      "
      @click.prevent="goDetail(prevNews)"
      v-gio-track="{
        event: 'clickPage',
        attrs: {
          pageCode_var: route.meta.pageCode,
          modulePosition_var: '-',
          moduleType_var: '-',
          moduleName_var: '新闻详情-上一条',
          pageClickName_var: prevNews.titleCn,
          $title: '-',
        },
      }"
    >
      <JcImg :level="1"
        v-if="
          getCnOrEn(
            prevNews?.coverPictureFileCnUrl,
            prevNews?.coverPictureFileUrl,
          )
        "
        :src="
          getCnOrEn(
            prevNews?.coverPictureFileCnUrl,
            prevNews?.coverPictureFileUrl,
          )
        "
        :alt="getCnOrEn(prevNews?.titleCn, prevNews?.title)"
        class="logo shrink-0"
      />

      <div class="ml-2 flex flex-col">
        <p
          class="text-paper-200 text-sm font-popSB font-semibold leading-5 h-5"
        >
          {{ $t('knowledge.last') }}
        </p>

        <p
          class="truncate text-paper font-bold text-sm leading-6 my-2 w-[220px]"
        >
          {{ getCnOrEn(prevNews?.titleCn, prevNews?.title) }}
        </p>

        <p class="mt-auto recommend-arrow-content">
          {{
            filterContent(
              getCnOrEn(
                prevNews?.contentCn || prevNews?.content,
                prevNews?.content || prevNews?.contentCn,
              ),
            )
          }}
        </p>
      </div>
    </a>

    <a
      v-if="nextNews"
      class="recommend-arrow mt-8 mb-4"
      :href="
        getLineHref(`/${currentType}/${nextNews.id}/`, isCn ? '/cn' : '/en')
      "
      @click.prevent="goDetail(nextNews)"
      v-gio-track="{
        event: 'clickPage',
        attrs: {
          pageCode_var: route.meta.pageCode,
          modulePosition_var: '-',
          moduleType_var: '-',
          moduleName_var: '新闻详情-下一条',
          pageClickName_var: nextNews.titleCn,
          $title: '-',
        },
      }"
    >
      <JcImg :level="1"
        v-if="
          getCnOrEn(
            nextNews?.coverPictureFileCnUrl,
            nextNews?.coverPictureFileUrl,
          )
        "
        :src="
          getCnOrEn(
            nextNews?.coverPictureFileCnUrl,
            nextNews?.coverPictureFileUrl,
          )
        "
        :alt="getCnOrEn(nextNews?.titleCn, nextNews?.title)"
        class="logo shrink-0"
      />
      <div class="ml-2 flex flex-col">
        <p
          class="text-paper-200 text-sm font-popSB font-semibold leading-5 h-5"
        >
          {{ $t('knowledge.next') }}
        </p>

        <p
          class="truncate text-paper font-bold text-sm leading-6 my-2 w-[220px]"
        >
          {{ getCnOrEn(nextNews?.titleCn, nextNews?.title) }}
        </p>
        <p class="mt-auto recommend-arrow-content">
          {{
            filterContent(
              getCnOrEn(
                nextNews?.contentCn || nextNews?.content,
                nextNews?.content || nextNews?.contentCn,
              ),
            )
          }}
        </p>
      </div>
    </a>

    <ApplyMemberShip />
  </div>
</template>

<script lang="ts" setup>
  import { getListDetail } from '~/api/news'

  const route = useRoute()
  const newsDetail = ref<any>({})
  const prevNews = ref<any>()
  const nextNews = ref<any>()

  const { locale } = useI18n()
  const { getLineHref } = useLineHref()

  const currentNewsId = computed(() => route.params.id)
  const currentNewsName = computed(() => route.name)

  // 这里改动了：增加了新增的 4 种详情页路由到对应的国际化标签映射
  const currentNewsTag = computed(() => {
    if (currentNewsName.value === 'knowledgeNewsDetail')
      return 'knowledge.freight_knowledge'
    if (currentNewsName.value === 'regionsNewsDetail')
      return 'knowledge.freight_area'
    if (currentNewsName.value === 'experienceNewsDetail')
      return 'knowledge.freight_experience'
    if (currentNewsName.value === 'solutionsNewsDetail')
      return 'knowledge.freight_solutions'
    if (currentNewsName.value === 'policyNewsDetail')
      return 'knowledge.freight_policy'
    if (currentNewsName.value === 'logisticsNewsDetail')
      return 'knowledge.logistics_news'
    return 'knowledge.jctrans_news'
  })

  // 这里改动了：增加了新增的 4 种详情页路由到路径前缀（type）的映射
  const currentType = computed(() => {
    if (currentNewsName.value === 'knowledgeNewsDetail') return 'news-knowledge'
    if (currentNewsName.value === 'regionsNewsDetail') return 'news-regions'
    if (currentNewsName.value === 'experienceNewsDetail')
      return 'news-experience'
    if (currentNewsName.value === 'solutionsNewsDetail') return 'news-solutions'
    if (currentNewsName.value === 'policyNewsDetail') return 'news-policy'
    if (currentNewsName.value === 'logisticsNewsDetail') return 'news'
    return 'jctransnews'
  })

  const prefix = computed(() => {
    return locale.value === 'zh-CN' ? '/cn' : '/en'
  })
  const isCn = computed(() => {
    return locale.value === 'zh-CN'
  })

  const goDetail = (data: any) => {
    if (!data) return

    navigateTo({
      path: `${prefix.value}/${currentType.value}/${data.id}/`,
    })
  }

  const { data, refresh, clear } = useAsyncData(
    'getListDetail',
    () => getListDetail({ id: currentNewsId.value }),
    {
      immediate: true,
    },
  )

  function getFirstPText(html: string): string {
    if (!html) return ''
    const match = html.match(/<p[^>]*>([\s\S]*?)<\/p>/i)
    if (!match) return ''
    const inner = match[1]
    return inner
      .replace(/<[^>]+>/g, '')
      .replace(/\s+/g, ' ')
      .trim()
  }

  // 这里改动了：全面升级 SEO 逻辑，补充了 5 种知识库分类独有的 TDK 渲染规则
  function updateSEO() {
    const detail = newsDetail.value || {}
    if (!detail.id) return

    let title = ''
    let description = ''
    let keywords = ''

    const titleCn = detail.titleCn || detail.title || ''
    const titleEn = detail.title || detail.titleCn || ''
    const contentCnText = getFirstPText(detail.contentCn)
    const contentEnText = getFirstPText(detail.content)

    // 截取中文正文前 80 字，英文前 160 字符
    const summaryCn = contentCnText.substring(0, 80)
    const summaryEn = contentEnText.substring(0, 160)

    if (currentType.value === 'news-knowledge') {
      if (isCn.value) {
        title = `${titleCn}-JCtrans杰西圈`
        keywords = '货运百科, 国际物流实务'
        description = `关于“${titleCn}”${summaryCn}。在国际货运中的应用场景、核心操作流程及常见注意事项。通过JCtrans货运知识库，轻松掌握货运相关行业准则。`
      } else {
        title = `${titleEn} - JCtrans`
        keywords = 'Logistics Encyclopedia, International Shipping Practice'
        description = `About "${titleEn}": ${summaryEn}. Explore practical applications in international freight, core operational workflows, and key precautions. Master Freight and industry standards with JCtrans Logistics Knowledge Hub.`
      }
    } else if (currentType.value === 'news-regions') {
      if (isCn.value) {
        title = `${titleCn}- JCtrans杰西圈`
        keywords = '货运成本, 海关流程, 贸易习惯, 跨境物流指南, 当地风土人情'
        description = `${summaryCn}。JCtrans货运地区频道涵盖当地货运成本构成、海关清关流程及禁限运规定。助力企业掌握海外市场准入规则。`
      } else {
        title = `${titleEn} - JCtrans`
        keywords =
          'Shipping Costs, Customs Procedures, Trade Customs, Cross-Border Logistics Guide, Local Business Etiquette'
        description = `${summaryEn}. JCtrans Shipping Regions covers local shipping cost structures, customs clearance procedures, and prohibited/restricted items. Empowering businesses to master overseas market access regulations.`
      }
    } else if (currentType.value === 'news-experience') {
      if (isCn.value) {
        title = `${titleCn}-货运实战案例分享 - JCtrans杰西圈`
        keywords = '货运案例, 行业实操, 货运经验'
        description = `关于“${titleCn}”：${summaryCn}。分享真实货运场景下的操作经验、风险预警及解决方案。通过JCtrans专业物流社区，获取一线货代专家的实战建议与避坑策略。`
      } else {
        title = `${titleEn}-JCtrans`
        keywords =
          'Shipping Case Study, Logistics Operations, Freight Forwarding Experience'
        description = `Insights on "${titleEn}": ${summaryEn}. Discover professional operational experiences, risk warnings, and practical solutions in real-world shipping scenarios. Access firsthand expert advice and "avoiding pitfalls" strategies via the JCtrans logistics community.`
      }
    } else if (currentType.value === 'news-solutions') {
      if (isCn.value) {
        title = `${titleCn}-货运解决方案-JCtrans杰西圈`
        keywords = '货运解决方案, 国际物流服务'
        description = `关于“${titleCn}”：${summaryCn}。通过JCtrans定制化物流服务，提升跨境运输效率。`
      } else {
        title = `${titleEn} - JCtrans`
        keywords = 'Freight Solutions, International Logistics Services'
        description = `About "${titleEn}": ${summaryEn}. Enhance Freight cross-border shipping efficiency with JCtrans’ tailored logistics services and expert operational support.`
      }
    } else if (currentType.value === 'news-policy') {
      if (isCn.value) {
        title = `${titleCn}-货运政策解读-JCtrans杰西圈`
        keywords = '货运政策'
        description = `关于“${titleCn}”${summaryCn}。JCtrans帮助物流企业快速调整跨境货运方案与合规策略。`
      } else {
        title = `${titleEn}-Freight Policy Analysis- JCtrans`
        keywords = 'Freight Policy, Shipping Regulations'
        description = `Deep dive into "${titleEn}": ${summaryEn}. JCtrans helps logistics companies quickly adapt cross-border shipping solutions and ensure regulatory compliance.`
      }
    } else {
      // 其他基础新闻类型保持原样
      title = isCn.value ? `${titleCn}-JCtrans杰西圈` : `${titleEn}-JCtrans`
      keywords = isCn.value ? titleCn : titleEn
      description = isCn.value ? contentCnText : contentEnText
    }
    if (isCn.value && detail.tcn) {
      title = detail.tcn
    } else if (!isCn.value && detail.ten) {
      title = detail.ten
    }
    if (isCn.value && detail.kcn) {
      keywords = detail.kcn
    } else if (!isCn.value && detail.ken) {
      keywords = detail.ken
    }
    if (isCn.value && detail.dcn) {
      description = detail.dcn
    } else if (!isCn.value && detail.den) {
      description = detail.den
    }
    useHead({
      title: title,
      meta: [
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
      ],
      titleTemplate: null,
    })
  }

  if (data.value?.data) {
    newsDetail.value = data.value.data.currentVo || {}
    prevNews.value = data.value.data.previousVo
    nextNews.value = data.value.data.nextVo

    if (!data.value.data.currentVo) {
      handleClickTag()
    } else {
      updateSEO()
    }
  }

  // 这里改动了：增加了对 4 种新增类型的 Tag 点击返回列表页的路由分发支持
  function handleClickTag() {
    if (currentType.value === 'news-knowledge')
      navigateTo({ name: 'knowledgeNews' })
    else if (currentType.value === 'news-regions')
      navigateTo({ name: 'regionsNews' })
    else if (currentType.value === 'news-experience')
      navigateTo({ name: 'experienceNews' })
    else if (currentType.value === 'news-solutions')
      navigateTo({ name: 'solutionsNews' })
    else if (currentType.value === 'news-policy')
      navigateTo({ name: 'policyNews' })
    else if (currentType.value === 'jctransnews')
      navigateTo({ name: 'jctransNews' })
    else if (currentType.value === 'news') navigateTo({ name: 'logisticsNews' })
  }

  watchEffect(async () => {
    const id = currentNewsId.value
    if (id) {
      await refresh()
      if (data.value?.data) {
        newsDetail.value = data.value.data.currentVo || {}
        prevNews.value = data.value.data.previousVo
        nextNews.value = data.value.data.nextVo

        if (!data.value.data.currentVo) {
          handleClickTag()
        } else {
          updateSEO()
        }
      }
    }
  })
</script>

<style lang="scss" scoped>
  @mixin text-overflow($t) {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: $t;
    word-break: break-word;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
  }

  .news-detail {
    padding: 16px;

    .news-title {
      font-family: Poppins-B, Poppins;
      font-size: 18px;
      font-weight: 900;
      line-height: 21px;
      color: #232324;

      @include text-overflow(2);
    }

    .news-tag {
      // width: 100px;
      display: inline-block;
      padding: 0 8px;
      white-space: nowrap;
      height: 18px;
      font-family: Poppins-R, Poppins;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: #bd5339;
      text-align: center;
      background: linear-gradient(270deg, #fae5cd 0%, #f4be9c 100%);
      border-radius: 2px;
    }

    .news-time {
      height: 18px;
      font-family: Poppins-R, Poppins;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      color: #727377;
      text-align: left;
      text-transform: none;
    }

    .recommend-arrow {
      display: flex;

      .logo {
        width: 102px;
        height: 102px;
        border-radius: 2px;
      }

      .recommend-arrow-content {
        @include text-overflow(2);

        font-family: Poppins-R, Poppins;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: #9ea0a6;
      }
    }
  }
</style>
